import React, { Component } from "react";
import "./OnetoOneView.css";

class OnetoOneView extends Component {
  render() {
    return (
      <div>
        <div id="agora_local_stream"></div>
        <div id="agora_other_stream"></div>
        <div>
          <svg id="visualizer" className="visualizer"></svg>
        </div>
      </div>
    );
  }
}

export default OnetoOneView;
